import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/http'

// LIST ALL Tracking Platforms
export const trackingList = (params = '') => Http.get(`/marketing-tracking-platforms${serialize(params)}`)
export const trackingCreate = (params = '') => Http.post('/marketing-tracking-platforms', params)
export const trackingByID = (params = '') => Http.get(`/marketing-tracking-platforms/${params}`)
export const trackingUpdate = (params = '') => Http.put(`/marketing-tracking-platforms/${params.id}`, params)
export const trackingDestroy = (params = '') => Http.delete(`/marketing-tracking-platforms/${params.id}`)
